import * as yup from 'yup';

function effectiveDate(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_EFFFECTIVE_DATE_FIELD_IS_REQUIRED',
      defaultMessage: 'Effective date is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      effectiveDate: effectiveDate(formatMessage),
    })
    .required();

export default validationSchema;
